import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Tabs, Tab } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BillingSettingsTab } from '../BillingSettingsTab';
import { OccupancyTab } from '../OccupancyTab';
import useStyles from '../styles';
export default function SolutionTab(_ref) {
  let isOpen = _ref.isOpen,
    accountId = _ref.accountId,
    livableTab = _ref.livableTab,
    propertyId = _ref.propertyId,
    residencyId = _ref.residencyId,
    handleGlobalTabChange = _ref.handleGlobalTabChange,
    parentToggleRefreshCallback = _ref.parentToggleRefreshCallback;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const tabs = [{
    label: t('unit_modal.occupancy'),
    name: 'livable-solution'
  }, {
    label: t('unit_modal.billing_settings'),
    name: 'billing-settings'
  }];
  const _useState = useState(livableTab || 'livable-solution'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  const handleTabChange = (e, newValue) => {
    if (newValue) setSelectedTab(newValue);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.tabWithFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contentTabs
  }, /*#__PURE__*/React.createElement(Tabs, {
    "aria-label": "tabs",
    onChange: handleTabChange,
    type: "navigation",
    value: selectedTab
  }, tabs.map(tab => /*#__PURE__*/React.createElement(Tab, {
    key: tab.name,
    label: tab.label,
    value: tab.name
  })))), selectedTab === 'livable-solution' ? /*#__PURE__*/React.createElement(OccupancyTab, {
    residencyId: residencyId,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }) : /*#__PURE__*/React.createElement(BillingSettingsTab, {
    isOpen: isOpen,
    residencyId: residencyId,
    accountId: accountId,
    handleTabChange: handleGlobalTabChange,
    propertyId: propertyId,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }));
}